module.exports = __webpack_public_path__ + "img/Card_spade_3.f984cc55.svg";